import { autoserialize } from 'cerialize';

export class AbstractPaginatedResultList {
  @autoserialize
  resultOffset: number;
}
